// https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
/* eslint-disable no-shadow */
export const SERVICE_PAGE_NAME = 'service-page';
export const SERVICE_PAGE_SLOT_ID = 'slot1';
export const SERVICE_LIST_PAGE_NAME = 'book-online';
export const SUBSCRIPTION_PRICING_EXPERIMENT =
  'specs.bookings.SubscriptionPricingUoU';
export const SHOW_REMAINING_COURSE_SESSIONS_EXPERIMENT =
  'specs.bookings.ShowRemainingCourseSessions';
/**
 * The same spec the Daily Agenda courses work uses. One toggle keeps the two
 * widgets in step: a visitor who enrolls from a course row lands here, and the
 * page has to describe the course the same way the row did.
 */
export const COURSES_EXPERIMENT = 'dailyAgendaCourses';
/** The same spec the Booking Form and the Service List use for monthly automatic discounts. */
export const ALLOW_MONTHLY_PRICING_AUTOMATIC_DISCOUNTS =
  'allowMonthlyPricingAutomaticDiscountsBO';
export const SERVICE_DETAILS_WDS_MIGRATION =
  'specs.bookings.serviceDetailsWdsMigration';
export const MIGRATE_BOOKINGS_THUMBNAIL_TO_WDS =
  'migrateBookingsThumbnailToWDS';
export const SERVICE_PAGE_NOT_FOUND_WITHOUT_SLUG_EXPERIMENT =
  'servicePageNotFoundWithoutSlug';

export enum FailReasons {
  Premium = 'premium',
  PricingPlanNotInstalled = 'pricing_plan_not_installed',
  NoPlansAssignedToService = 'no_plans_assigned_to_service',
}
